module.exports = __webpack_public_path__ + "assets/img/icon-1.72f24f8f.png";